/**
 * User-facing texts (Spanish). Centralized so they can be translated later.
 * Code and identifiers stay in English.
 */
export const es = {
  errors: {
    bad_request: "La solicitud no es válida.",
    unauthorized: "Inicia sesión para continuar.",
    forbidden: "No tienes permiso para hacer esto.",
    not_found: "No encontramos lo que buscas.",
    conflict: "La operación entra en conflicto con datos existentes.",
    tenant_required: "Selecciona una empresa para continuar.",
    two_factor_required: "Activa la verificación en dos pasos para seguir usando el panel.",
    window_closed: "Pasaron más de 24 horas desde el último mensaje del cliente. Envía una plantilla aprobada.",
    internal: "Ocurrió un error inesperado. Intenta de nuevo.",
  },
  roles: {
    owner: {
      label: "Propietario",
      summary: "Control total de la empresa: equipo, roles, configuración y, más adelante, el plan y los pagos.",
    },
    admin: {
      label: "Administrador",
      summary:
        "Administra la bandeja y la configuración: cualquier conversación, respuestas rápidas, plantillas y el equipo.",
    },
    agent: {
      label: "Asesor",
      summary:
        "Atiende clientes: responde las conversaciones sin asignar y las que tiene asignadas, y edita contactos.",
    },
  },
  whatsapp: {
    /** Phase 0 fixed reply. Replaced by the AI agent in phase 3. */
    phase0AutoReply: "¡Hola! Recibimos tu mensaje. Este número está en pruebas con Orbis y pronto te responderemos.",
  },
} as const;

export type Messages = typeof es;
